import { Pipe, PipeTransform } from '@angular/core';
import { UtilityService } from '../services/utility.service';
import memo from 'memo-decorator';

/**Pure pipe per recuperare il colore associato a un tipo di ruolo utente */
@Pipe({
  name: 'roleColor'
})
export class RoleColorPipe implements PipeTransform {

  /**
   * Costruttore per la classe RoleColorPipe
   * @param utility {UtilityService} classe che raccoglie un'insieme di servizi di utilità
   */
  constructor(private utility: UtilityService) {}

  /**
   * Metodo dell'interfaccia PipeTransform
   * @param glossary {Glossary} voce di glossario del cui autore si deve recuperare il colore [o anche della traduzione]
   * @returns {object}
   */
  @memo()
  transform(glosAccountType: string): {} {
    let color = this.utility.getTranslatedString('ruoli.' + glosAccountType + 'color');
    return {'color': color};
  }

}
